"use strict";

exports.__esModule = true;
exports.RequiredLabel = RequiredLabel;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Label = _styledComponents["default"].span.withConfig({
  displayName: "RequiredLabel__Label",
  componentId: "sc-1642bpc-0"
})(["padding:0 0.2rem;margin:0;color:", ";font-style:italic;font-size:", ";"], (0, _Theme.val)("RequiredLabelColor"), (0, _Theme.val)("fontSizeXS"));

/**
 * Displays a header for the top of a screen, panel or section.
 */
function RequiredLabel(_ref) {
  var children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Label, extra, children || "*");
}